import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, Chapter } from "./Reveal";
import { FINISHES, FEATURED_FINISHES } from "@/data/finishes";

const Products = () => (
  <section id="products" className="relative bg-coal border-t border-bone/10 px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="products-section">
    <div className="flex flex-col gap-6 mb-16">
      <Reveal><Chapter index="03" title="The Collection" testid="products-chapter" /></Reveal>
      <Reveal delay={0.1} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <h2 className="text-4xl sm:text-5xl font-heading font-bold leading-[1.05] max-w-2xl" data-testid="products-heading">
          One stone. <span className="font-editorial italic font-medium text-copper">many finishes.</span>
        </h2>
        <p className="max-w-sm text-sm md:text-base font-light text-bone/60 leading-relaxed">
          Mined, calibrated and finished across our Kota units — then checked by hand before dispatch.
        </p>
      </Reveal>
    </div>
    <div className="grid grid-cols-12 gap-4 md:gap-5">
      {FEATURED_FINISHES.map((p, i) => (
        <Reveal key={p.id} delay={(i % 3) * 0.08} className={p.span}>
          <Link to={`/finishes/${p.id}`} className="product-tile group relative block w-full overflow-hidden bg-stone text-left" data-testid={`product-card-${p.id}`} aria-label={`${p.name} — view specifications and photos`}>
            <img src={p.cover} alt={`${p.name} — ${p.finish} by Garg Stone Company`} loading="lazy" className="absolute inset-0 h-full w-full object-cover grayscale-[25%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0" data-testid={`product-image-${p.id}`} />
            <span className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
            <span className="absolute top-5 right-5 font-editorial italic text-lg text-bone/60">{String(i + 1).padStart(2, "0")}</span>
            <span className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6">
              <span className="min-w-0">
                <span className="block text-xs uppercase font-heading text-copper mb-2" data-testid={`product-finish-${p.id}`}>{p.finish}</span>
                <span className="block font-heading font-extrabold uppercase text-2xl md:text-3xl" data-testid={`product-name-${p.id}`}>{p.name}</span>
                <span className="mt-3 block text-xs text-bone/75">View finish & specifications</span>
              </span>
              <ArrowUpRight size={23} className="shrink-0 text-copper transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
    <Reveal className="mt-14">
      <h3 className="font-heading text-sm uppercase text-bone/50 mb-6" data-testid="more-finishes-heading">More from the collection</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-bone/15" data-testid="products-also-available">
        {FINISHES.filter((p) => !p.featured).map((p) => (
          <Link key={p.id} to={`/finishes/${p.id}`} className="group flex items-center justify-between gap-3 border-b border-bone/15 py-5 sm:mr-7 text-sm text-bone/75 transition-colors duration-300 hover:text-copper" data-testid={`finish-link-${p.id}`}>
            {p.name}<ArrowUpRight size={16} className="shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </Reveal>
  </section>
);

export default Products;